import { render, staticRenderFns } from "./ThumbnailActions.vue?vue&type=template&id=56c6d7e0"
import script from "./ThumbnailActions.vue?vue&type=script&lang=js"
export * from "./ThumbnailActions.vue?vue&type=script&lang=js"
import style0 from "./ThumbnailActions.vue?vue&type=style&index=0&id=56c6d7e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports